import $ from 'jquery';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import EngineServers from './EngineServers';
import ENGINES, { getEngineIndex } from '../../../utils';


const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
});

function getEngine(cores, qtEngine) {
  if (qtEngine) return ENGINES.indexOf(qtEngine)
  if (cores) return getEngineIndex(cores)
  return 0
}

class EnginesTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enginesList: [],
      enginesOptionsList: {},
      selectedEngineOptions: {},
      selectedEngineIndex: getEngine(props.user.server, props.qtEngine)
    };
  }

  componentDidMount() {
    $.ajax({
      url: '/billing/get_engines_list',
      success: enginesList => { this.setState({ enginesList }) }
    });

    $.ajax({
      url: '/billing/get_engines_options_list',
      success: enginesOptionsList => {this.setState({ enginesOptionsList }) 
      }
    });
  }

  handleChangeEngine = (event, index) => {
    const { restartInterval } = this.props;
    const engine = ENGINES[index];
    restartInterval(engine);
    window.history.replaceState({ page: 1 }, ENGINES[index], `?client=1&engine=${engine}`);
    this.setState({ selectedEngineIndex: index });
  }

  handleChangeOptions = (event, option, engine, type) => {
    const {value, checked} = event.target;
    const {enginesOptionsList} = this.state;
    if (type === 'option'){
      enginesOptionsList[engine][option].options.sort(function(x,y){ return x == value ? -1 : y == value ? 1 : 0; });
    }else if (type === 'number'){
      const num = typeof value === 'number'? parseFloat(value): value;
      const { valid_range } = enginesOptionsList[engine][option];
      if(!num || valid_range[0] <= num && num <= valid_range[1]){
        enginesOptionsList[engine][option].options[0] = num;
      }
    }else if (type === 'boolean'){
      enginesOptionsList[engine][option].options[0] = checked;
    }
    this.setState({enginesOptionsList})
  }

  render() {
    const { classes, user, qtEngine } = this.props;
    const { enginesList, selectedEngineIndex, enginesOptionsList, selectedEngineOptions } = this.state;   
    
    return (
      <div className={classes.root}>
        {
          !user.server && !qtEngine &&
          <AppBar position="static" color="default">
            <Tabs
              value={selectedEngineIndex}
              onChange={this.handleChangeEngine}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              {enginesList.map(engine => <Tab key={engine} label={engine} />)}
            </Tabs>
          </AppBar>
        }
        <EngineServers selectedEngineIndex={selectedEngineIndex} 
                       selectedEngineOptions={selectedEngineOptions} 
                       enginesOptionsList={enginesOptionsList} 
                       handleChangeOptions={this.handleChangeOptions} 
                       user={user} 
                       />
      </div>
    );
  }
}

export default withStyles(styles)(EnginesTabs);
